import Vue from 'vue';
import {handleErrors} from '@/services/ErrorHandling';

const self = Vue.prototype;

export default {
  updateShipper(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUpdateShipper, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  searchByMailbox(mailbox, limit) {
    const query = `?mailbox=${mailbox}&limit=${limit}`;
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSearchByMailbox + query)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error, reject)
        })
    })
  },
  getFilteredUsers(query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUser + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  createUser(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminUser, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getUserForUpdate(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUser + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPointsTransaction(id, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUser + `/points-transaction/${id}?page=${page}&per_page=${perPage}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUser(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUser + '/update', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  changeUserStatus(body) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUser + '/change-active-status', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  confirm(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUser + `/confirm/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminUser + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getTypesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUser + '/types-map')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getCartItems(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminUser + `/cart-items/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setPaidCartByCash(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUser + `/cart-paid-cash/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setPaidCartBySquare(id) {
    return new Promise((resolve, reject) => {
      self.axios.put(self.$apiRouter.adminUser + `/cart-paid-square/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
